import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { getRemainingCharsHintText } from './shared';
import { getRemainingCharsStyles } from './style';

export function withControlledRemainingCharsUnvalidated(WrappedComponent) {
  const RemainingCharsHOC = (props) => {
    const {
      maxLengthHint,
      i18n,
      value,
    } = props;

    const classes = useDefaultStyles(getRemainingCharsStyles);

    return (
      <React.Fragment>
        <WrappedComponent {...props} />
        <div className={classnames('remaining-chars-container', classes.RemainingCharsContainer)} >
          { getRemainingCharsHintText(value, i18n, maxLengthHint) }
        </div>
      </React.Fragment>
    );
  };

  RemainingCharsHOC.propTypes = {
    i18n: PropTypes.shape({}).isRequired,
    maxLengthHint: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  };


  RemainingCharsHOC.displayName = `withControlledRemainingCharsUnvalidated(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(RemainingCharsHOC, WrappedComponent);

  return RemainingCharsHOC;
}
